import React from 'react'
import ProgressUI from '../../widgets/output/ProgressUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import LabelAndValueUI from '../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import InvoiceListUI from '../../components/finapp/invoice/InvoiceListUI'
import OrderHeaderUI from '../../components/finapp/order/OrderHeaderUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import InvoiceCreateModalSF from '../../components/finapp/invoice/InvoiceCreateModalSF'
import './OrderInvoiceListPage.css'

const OrderInvoiceListPageUI = ({ context, messageList, errorList, order, invoiceList, filteredInvoiceList,
  searchFilter, onRefreshClick, onSearchFilterChange,
  onCreateInvoiceClick, createInvoiceMode, onCancelCreateInvoice, onCreateInvoiceComplete
}) =>
  <PrivatePageSF context={context} className='pg_ord_invs' backLink='/orders'
    messageList={messageList} headerMessageKey='c_invoices'
    centered={(!order || !invoiceList) && !errorList}
  >
    {
      (!order || !invoiceList) && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      order && invoiceList &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink='/orders'
          messageList={messageList} titleMessageKey='c_invoices'
        />
        <OrderHeaderUI context={context} messageList={messageList} order={order} />
        <InvoiceListHeaderUI context={context} messageList={messageList} order={order} />
      </React.Fragment>
    }
    {
      invoiceList && invoiceList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        onCreateClick={onCreateInvoiceClick}
        createLinkKey='c_create_invoice'
        createDisabledMessageKey='c_no_invoice_msg'
      />
    }
    {
      order && invoiceList && filteredInvoiceList && invoiceList.length !== 0 &&
      <InvoiceListUI
        context={context}
        order={order}
        invoiceList={filteredInvoiceList}
        messageList={messageList}
        searchFilter={searchFilter}
        // events
        onCreateClick={onCreateInvoiceClick}
        onRefreshClick={onRefreshClick}
        onSearchFilterChange={onSearchFilterChange}
      />
    }
    <InvoiceCreateModalSF context={context} createMode={createInvoiceMode}
      onCancelClick={onCancelCreateInvoice} onCreateComplete={onCreateInvoiceComplete}
    />
  </PrivatePageSF>

const InvoiceListHeaderUI = ({ context, messageList, order }) =>
  <React.Fragment>
    <div className='g_flex_h g_m_top_50'>
      <div>
        <LabelAndValueUI messageList={messageList} labelKey='c_payments'>
          {order.paymentTotalF2}
        </LabelAndValueUI>
        <ProgressUI messageList={messageList} percent={order.invoicePaidPercent} />
      </div>
      <LabelAndValueUI messageList={messageList} labelKey='c_invoice_total' align='right'>
        {order.invoiceTotalF2}
      </LabelAndValueUI>
    </div>
  </React.Fragment>

export default OrderInvoiceListPageUI
